// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Attributes-base__OGhFJ{display:flex;flex-wrap:wrap;gap:var(--size-2);align-items:center;padding-top:var(--size-1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "Attributes-base__OGhFJ"
};
export default ___CSS_LOADER_EXPORT___;
